import React, {useEffect, useState, useCallback} from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Input, HStack, VStack, Spinner,
} from '@chakra-ui/react';
import axios from 'axios';
import config from './config';

const AddDeviceIdModal = ({userToken, isOpen, onClose}) => {
    const [deviceList, setDeviceList] = useState(null);
    const [deviceName, setDeviceName] = useState('');
    const [deviceId, setDeviceId] = useState('');
    const [showSubmitButton, setShowSubmitButton] = useState(true);

    const resetForm = () => {
        setDeviceName('');
        setDeviceId('');
    };

    const fetchDeviceData = useCallback(() => {
        let bearerToken = "Bearer " + userToken;
        axios.get(config.API_ENDPOINT + '/user/get_device_data', {headers: {Authorization: bearerToken}})
            .then((response) => {
                setDeviceList(response.data);
            })
            .catch((error) => {
                console.error("Error fetching device data:", error);
                setDeviceList([]);
            });
    }, [isOpen]);

    const handleSubmit = (event) => {
        console.log("handleSubmitCalled");
        setShowSubmitButton(false);
        axios.post(config.API_ENDPOINT + '/user/device',
            deviceList,
            {headers: {Authorization: "Bearer " + userToken}})
            .then((response) => {
                console.log(response);
                resetForm();
                setShowSubmitButton(true);
                onClose();
            });
    };

    useEffect(() => {
        if (isOpen && deviceList === null) {
            fetchDeviceData();
        }
    }, [isOpen, deviceList, fetchDeviceData]);

    function updateDeviceId(index, device_id) {
        const temp = [...deviceList];
        temp[index].device_id = device_id;
        setDeviceList(temp);
    }

    function updateDeviceName(index, device_name) {
        const temp = [...deviceList];
        temp[index].device_name = device_name;
        setDeviceList(temp);
    }

    function deleteDevice(index) {
        const temp = [...deviceList];
        temp.splice(index, 1);
        setDeviceList(temp);
    }

    function addDevice(index) {
        const temp = [...deviceList];
        temp.push({device_name: deviceName, device_id: deviceId});
        setDeviceName('')
        setDeviceId('');
        setDeviceList(temp);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent maxW="56rem">
                <ModalHeader>Add Device Id</ModalHeader>
                <ModalCloseButton />
                <form onSubmit={handleSubmit}>
                    <ModalBody maxW={'600px'}>
                        {deviceList && deviceList.map((device, index) =>  (
                            <HStack key={index} paddingBottom={'10px'}  width={'850px'}>
                                <Input width={'350px'} value={device.device_name} onChange={(event) => updateDeviceName(index, event.target.value)}/>
                                <Input width={'350px'} value={device.device_id} onChange={(event) => updateDeviceId(index, event.target.value)} />
                                <Button variant="outline" width={'150px'} colorScheme="red" mr={3} onClick={()=>deleteDevice(index)}>Delete</Button>
                            </HStack>))}
                        <HStack paddingBottom={'10px'}  width={'850px'}>
                        <Input  width={'350px'} placeholder='Device Name'  value={deviceName} onChange={(event) => setDeviceName(event.target.value)} />
                        <Input  width={'350px'} placeholder='IOS/Android Device Id'  value={deviceId} onChange={(event) => setDeviceId(event.target.value)} />
                            <Button variant="outline" width={'150px'} colorScheme="blue" mr={3} onClick={()=>addDevice()}>Add</Button>
                        </HStack>
                    </ModalBody>
                    <ModalFooter>
                        {showSubmitButton &&
                            <Button variant="outline" mr={3} onClick={()=>handleSubmit()}>Submit</Button>
                        }
                        {!showSubmitButton &&
                          <Spinner/>
                        }
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
};

export default AddDeviceIdModal;
